import { StatisticsAdapter } from "./StatisticsAdapter";
import { ProjectDomUtils } from "../../utils/ProjectDomUtils";
import { URLUtils } from "../../utils/URLUtils";
import { DataUtils } from "../../utils/DataUtils";
export class AnalyticsScriptAdapter extends StatisticsAdapter {
    constructor() {
        super(...arguments);
        this._userTagManager = true;
    }
    init(data) {
        this._data = data;
        window.dataLayer = window.dataLayer || [];
        this._gtag = function () {
            window.dataLayer.push(arguments);
        };
        this._gtag('js', new Date());
        this._gtag('config', this._data.params.ua, { send_page_view: true });
    }
    initLazy() {
        if (!URLUtils.isLocalhost) {
            ProjectDomUtils.loadScript({ src: "https://www.googletagmanager.com/gtag/js?id=" + this._data.params.ua });
        }
    }
    trackPage(pathName, pageTitle = '', pageLocation = '') {
        if (this._userTagManager) {
            this._gtag('config', this._data.params.ua, {
                'page_title': pageTitle || pathName,
                'page_location': pageLocation || '',
                'page_path': pathName
            });
        }
        else if (this._ga) {
            if (pageTitle || pathName) {
                this._ga('send', 'pageview', {
                    page: pageTitle || pathName
                });
            }
            else {
                this._ga('send', 'pageview');
            }
        }
    }
    trackEvent(event) {
        if (!URLUtils.isLocalhost) {
            const nonInteraction = DataUtils.isNotNone(event.nonInteraction) ? event.nonInteraction : true;
            if (this._userTagManager) {
                this._gtag('event', 'event_name', {
                    'event_category': event.category,
                    'event_action': event.action,
                    'event_label': event.label,
                    'event_value': event.value,
                    'non_interaction': nonInteraction
                });
            }
            else if (this._ga) {
                this._ga('send', {
                    hitType: 'event',
                    eventCategory: event.category,
                    eventAction: event.action,
                    eventLabel: event.label,
                    eventValue: event.value,
                    nonInteraction: nonInteraction
                });
            }
        }
        else {
            logger.log('analytics localhost: ' + event.category + ' ' + event.action + ' ' + event.label + ' ' + event.value);
        }
    }
}
